
    var host = window.location.host;
    var sub = host.split('.')[0];
	if(sub == 'trial50') { 
        document.location.href = 'https://natureszestnutrition.com/pages/promotional-lp';
    }


window.onload = function() {
        var elementToMove = document.querySelector('.slp-content'); 
        var targetLocation = document.querySelector('.loyaltyprogram-container');

        if (elementToMove && targetLocation) {
            targetLocation.appendChild(elementToMove);
        } else {
            console.error('Element or target location not found');
        }
    };



document.addEventListener('DOMContentLoaded', function() {
  const buyAgainButtons = document.querySelectorAll('.buyagain-cart');

  buyAgainButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const variantId = this.getAttribute('data-variant-id');
      addToCart(variantId);
    });
  });

  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    })
    .then(response => {
      if (response.ok) {
        // Redirect to the cart page
        window.location.href = '/cart';
      } else {
        throw new Error('Failed to add item to cart');
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      // Handle error (e.g., show an error message)
    });
  }
});





document.addEventListener('DOMContentLoaded', function() {
    // Function to process added elements
    function processElements() {
        var zeroPriceElement = document.querySelectorAll('.appstle_cart_sellingPlan_price');
        zeroPriceElement.forEach(function(el) {
            var zeroPriceElementText = el.textContent.replace("£","");
            var zeroPriceElementNumber = parseInt(zeroPriceElementText, 10);
            if(zeroPriceElementNumber == 0) {
                var zeroPriceElementParent = el.closest("div").parentElement;
                var quantitySelector = zeroPriceElementParent.previousElementSibling;
                quantitySelector.classList.add("zero-price");
                quantitySelector.style.pointerEvents = "none";
                
                // Adjust the quantity for zero-priced items
                adjustQuantityForZeroPricedItems(quantitySelector);
            }      
        });
    }

    // New function to adjust quantity for zero-priced items
    function adjustQuantityForZeroPricedItems(quantitySelector) {
        var quantityInput = quantitySelector.querySelector('input[type="number"]');
        if (quantityInput && parseInt(quantityInput.value, 10) > 1) {
            quantityInput.value = 1; // Set quantity back to 1
        }
    }

    // Function to revert pointer events to "auto" for quantitySelectors when applicable
    function revertPointerEvents() {
        var moneyElements = document.querySelectorAll('.money');
        moneyElements.forEach(function(el) {
            var quantitySelector = el.closest("div").parentElement.previousElementSibling;
            if (quantitySelector && quantitySelector.classList.contains("zero-price")) {
                quantitySelector.style.pointerEvents = "auto";
                quantitySelector.classList.remove("zero-price");
            }
        });
    }

    function mutationCallback(mutationsList, observer) {
        for(let mutation of mutationsList) {
            if(mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    if(node.nodeType === Node.ELEMENT_NODE) {
                        if(node.matches('.appstle_cart_sellingPlan_price') || node.querySelector('.appstle_cart_sellingPlan_price')) {
                            processElements();
                        }
                        if(node.matches('.money') || node.querySelector('.money')) {
                            revertPointerEvents();
                        }
                    }
                });
                mutation.removedNodes.forEach(node => {
                    if(node.nodeType === Node.ELEMENT_NODE) {
                        if(node.matches('.appstle_cart_sellingPlan_price') || node.closest('.appstle_cart_sellingPlan_price')) {
                            revertPointerEvents();
                        }
                    }
                });
            }
        }
    }

    var observer = new MutationObserver(mutationCallback);
    var config = { childList: true, subtree: true };
    observer.observe(document.body, config);

    // Initial processing
    processElements();
    function PromotionalItemQtyDisable() {
      let promotionalElement = document.querySelector('li[data-cartitem-id="45064186888460"');
      if(promotionalElement) {
        let qtyBox = promotionalElement.querySelector('.cart-item__quantity');
        qtyBox.classList.add("zero-price");
        qtyBox.style.pointerEvents = "none";
      }
    }
    PromotionalItemQtyDisable();
});


